/**
 * One id per outgoing message (#202): `op_` + 24 hex. The server treats a
 * chat or steer carrying the same `op_id` as the same message, so a retry
 * after a network failure returns the rows it already wrote instead of
 * writing them again.
 */
export function mintOpId(): string {
  const bytes = new Uint8Array(12);
  const c = (globalThis as any).crypto;
  if (c && typeof c.getRandomValues === 'function') c.getRandomValues(bytes);
  else for (let i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  return `op_${Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')}`;
}
